import { useState, useCallback, useEffect } from 'react'

export const usePDFields = <Original, Override>({
  objectId,
  paramsLoader,
}: {
  objectId: string
  paramsLoader: (
    id: string,
  ) => Promise<{ pdfParams: Original; overrideParams: Override } | null>
}) => {
  const [fields, setFields] = useState<Original | null>(null)
  const [overrideFields, setOverrideFields] = useState<Override | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const loadFields = useCallback(async () => {
    setLoading(true)
    const allParams = await paramsLoader(objectId)
    if (!allParams) {
      setLoading(false)

      return
    }
    setFields(allParams.pdfParams)
    setOverrideFields(allParams.overrideParams)
    setLoading(false)
  }, [objectId, paramsLoader])

  useEffect(() => {
    loadFields()
  }, [loadFields])

  const getFieldValue = useCallback(
    <T>(field: keyof Override): T | undefined => {
      return overrideFields?.[field] as T | undefined
    },
    [overrideFields],
  )

  return { fields, overrideFields, loading, setOverrideFields, getFieldValue }
}
